// TM-1000001816: Test-Harness-Registrierung fuer das HE-Modul (Integration
// Connection Registry). Registriert Config-Page, Object-Pages, Object-Components
// und Tabellen-Widgets, damit Test-Harness/E2E die Komponenten aufloesen koennen.
import {Provider} from '@angular/core';
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from '../../../core/shared/test/data/test-harness.types';
import {HeConfigPage} from '../page/he-config/he-config.page';
import {
    HeSftpConnectionObjectPage
} from '../page/object/he-sftp-connection-object-page/he-sftp-connection-object.page';
import {
    HeFtpConnectionObjectPage
} from '../page/object/he-ftp-connection-object-page/he-ftp-connection-object.page';
import {
    HeSftpConnectionObjectComponent
} from '../component/object-components/he-sftp-connection-object-component/he-sftp-connection-object.component';
import {
    HeFtpConnectionObjectComponent
} from '../component/object-components/he-ftp-connection-object-component/he-ftp-connection-object.component';
import {HeSftpConnectionTableComponent} from '../component/widgets/he-sftp-connection-table.component';
import {HeFtpConnectionTableComponent} from '../component/widgets/he-ftp-connection-table.component';

const heModuleEntry: TestModuleDefinition = {
    key: 'he',
    label: 'Integration Connection Registry (he)',
    components: [
        {
            key: 'HeConfigPage',
            component: HeConfigPage,
            selector: 'mvs-he-config',
            type: 'PageComponent',
            label: 'HE Config'
        },
        {
            key: 'HeSftpConnectionObjectPage',
            component: HeSftpConnectionObjectPage,
            selector: 'mvs-he-sftp-connection-page',
            type: 'PageComponent',
            label: 'SFTP-Verbindung Object Page'
        },
        {
            key: 'HeFtpConnectionObjectPage',
            component: HeFtpConnectionObjectPage,
            selector: 'mvs-he-ftp-connection-page',
            type: 'PageComponent',
            label: 'FTP-Verbindung Object Page'
        },
        {
            key: 'HeSftpConnectionObjectComponent',
            component: HeSftpConnectionObjectComponent,
            selector: 'mvs-he-sftp-connection-object',
            type: 'ObjectBaseComponent',
            label: 'SFTP-Verbindung Object'
        },
        {
            key: 'HeFtpConnectionObjectComponent',
            component: HeFtpConnectionObjectComponent,
            selector: 'mvs-he-ftp-connection-object',
            type: 'ObjectBaseComponent',
            label: 'FTP-Verbindung Object'
        },
        {
            key: 'HeSftpConnectionTableComponent',
            component: HeSftpConnectionTableComponent,
            selector: 'mvs-he-sftp-connection-table',
            type: 'component',
            label: 'SFTP-Verbindungen Tabelle'
        },
        {
            key: 'HeFtpConnectionTableComponent',
            component: HeFtpConnectionTableComponent,
            selector: 'mvs-he-ftp-connection-table',
            type: 'component',
            label: 'FTP-Verbindungen Tabelle'
        }
    ]
};

export const HE_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: heModuleEntry, multi: true}
];
